
import React from 'react';
import ViewIcons from '../Parts/ViewIcons';
import { FaLinkedinIn } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";

import { FaGithub,  FaWhatsapp } from "react-icons/fa6";

import imgAbout from '../../assets/about page.gif';
import { motion } from 'framer-motion';

import './about.css'

function About() {
  return (
    <div className='background' >
      <section id="home" >
        <div className="container">
          <div className="row align-items-center">
     <motion.div
              initial={{ opacity: 0, x: -100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 , ease: "easeInOut" ,delay: 0.2 }}

             className="col-xs-12 col-md-6 col-xl-7 fs-3 text-white info" >
              Hi Everyone, My Name is Weam Ibrahim Ahmed
              <p>
                I am a junior Fullstack Developer
              </p>
              I was Trainee At ITI for Open Source Professional Training Program (9 months) Alexandria
              , Egypt at 2023 and Graduated from Electronic and Communication At Faculty Of Engineering University Of Al Azhar At 2022

            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 , ease: "easeInOut" ,delay: 0.2 }}
              className="col-xs-12 col-md-6 col-xl-5">
              <img src={imgAbout} className="img" />
            </motion.div>
          </div>
        </div>


      </section>

      <section className='mb-5'>
        <h1 className="text-center text-white">FIND ME ON</h1>
        <h6 className="text-center text-white"> Feel free to connect with me</h6>

        <div className="text-center  my-3">
          <a href="https://github.com/weamibrahim">
            <FaGithub className="mx-3 icons" />
          </a>
          <a href="https://www.linkedin.com/in/weamibrahim/">
            <FaLinkedinIn className="mx-3 icons" />
          </a>
          <a href='https://www.facebook.com/weaam.ebrahim.3?mibextid=ZbWKwL'>
            <FaFacebookF className="mx-3 icons" />
          </a>

          <a href='https://wa.me/201008864924'>
            <FaWhatsapp className="mx-3 icons" />
          </a>
        </div>

      </section>

      <section >

        <h1 className="text-center text-white mt-5">SKILLS</h1>
        <ViewIcons/>
      </section>
    </div>
  );
}

export default About;
